import React from 'react';
import FEATURE_CONFIG, { getBrandIcon } from '../feature-config';

const FallbackIcon = ({ index, animatedState })=> {
    const extension = animatedState ? '-light.svg' : '.svg';
    const leftIndexes = [2,3,4];
    const src = leftIndexes.includes(index)
        ? `./images/ListingShareable/person-walking-left${extension}`
        : `./images/ListingShareable/person-walking-right${extension}`;

    return <img src={src} alt="" />;
};

const AreaIcon = ({ animatedState, category, placeName, index })=> {
    const BrandIcon = getBrandIcon(category, placeName);
    const FeatureIcon = FEATURE_CONFIG[category]
        ? FEATURE_CONFIG[category].icon || null
        : null;

    return (
        <>
            {BrandIcon && (
                <BrandIcon variant={`${animatedState ? 'light' : 'dark'}`} />
            )}

            {(!BrandIcon && FeatureIcon) && (
                <FeatureIcon fontSize="inherit" />
            )}

            {(!BrandIcon && !FeatureIcon) && (
                <FallbackIcon index={index} animatedState={animatedState} />
            )}
        </>
    )
}

export default AreaIcon;
